import config from '@/configs'
import moment from "moment"
import { currency } from "@/commons/currency";
import { display_date } from "@/commons/formater";
import { sendErrorNotice, refreshResource } from "@/commons/utils";
export function request_header(token) {
  return {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "accept": "application/json",
  };
}

export function request_payload(param) {
  let query = '';
  if(param && (param.pagination || param.qObject || param.filter || param.quickFilter)) {
    const page = param.pagination && param.pagination.page ? param.pagination.page : 1
    const rowsPerPage = param.pagination && param.pagination.itemsPerPage ? param.pagination.itemsPerPage : 1000000
    const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
    const descending = param.pagination ? param.pagination.sortDesc[0] : 1
    const qObject = param.qObject ? Buffer.from(JSON.stringify({ qObject: param.qObject })).toString("base64") : '';
    const filter = param.filter && param.filter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.filter })).toString("base64") : '';
    const quickFilter = param.quickFilter && param.quickFilter.length > 0 ? Buffer.from(JSON.stringify({ filter: param.quickFilter })).toString("base64") : '';
    query = `?filter=${filter}&qObject=${qObject}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}&q=${quickFilter}`;

    if('startTime' in param) {
      query += `&startTime=${param.startTime}`
    }
    if('endTime' in param) {
      query += `&endTime=${param.endTime}`
    }
    if('staffName' in param) {
      query += `&staffName=${param.staffName}`
    }
    if('method' in param) {
      query += `&method=${param.method}`
    }
    if('uid' in param) {
      query += `&uid=${param.uid}`
    }
  }
  else if(param && param.is_master) {
    const is_master = param.is_master || '';
    const fields = param.fields || [];
    query = `?is_master=${is_master}&fields=${fields.join(',')}`;
  }
  else if(param) {
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = `?${fields.join('&')}`;
  }

  if(param && 'bell' in param) {
    query += `&bell=${param.bell}`
  }
  return query;
}

export function request_list(endpoint, cb, $http, param, token) {
  const req = {
    headers: request_header(token)
  };
  
  const query = request_payload(param);

  $http.get(`${config.API}/admin/api/${endpoint}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function export_list(endpoint, cb, $http, param, token, func) {
  const req = {
    headers: request_header(token),
    responseType: 'blob'
  };
  func = func ? func : 'export'
  const query = request_payload(param)

  $http.get(`${config.API}/admin/api/${endpoint}/${func}/${query}`, req).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function import_list(endpoint, cb, $http, param, token, func) {
  const header = {
    headers: request_header(token)
  };
  header.headers['Content-Type'] = 'multipart/form-data';
  func = func ? func : 'import'

  $http.post(`${config.API}/admin/api/${endpoint}/${func}/`, param, header).then(function (res) {
    setTimeout(() => cb(res), 100);
  });
}

export function request_detail(endpoint, cb, $http, id, token, param) {
  const header = {
    headers: request_header(token)
  };
  let query = '';
  if(param) {
    if(param.pagination) {
      const page = param.pagination ? param.pagination.page : 1
      const rowsPerPage = param.pagination ? param.pagination.itemsPerPage : 1000000
      const sortBy = param.pagination ? param.pagination.sortBy[0] : 'ID'
      const descending = param.pagination ? param.pagination.sortDesc[0] : 1
      query = `?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&descending=${descending}`;
      delete param.pagination;
    }
    var fields = []
    Object.keys(param).forEach((key) => fields.push(`${key}=${param[key]}`));
    query = query == '' ? `?${fields.join('&')}` : `${query}&${fields.join('&')}`;
  }
  $http.get(`${config.API}/admin/api/${endpoint}/${id}${query}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
  });
}

export function update_detail(endpoint, cb, $http, param, pId, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  let path = pId == 0 ? `${config.API}/admin/api/${endpoint}/` : `${config.API}/admin/api/${endpoint}/${pId}`;
  $http.post(path, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      refreshResource();
    }
  });
}

export function remove_detail(endpoint, cb, $http, id, token) {
  const header = {
    headers: request_header(token)
  };
  $http.delete(`${config.API}/admin/api/${endpoint}/${id}`, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  });
}

export function create_detail(endpoint, cb, $http, param, token) {
  const header = {
    headers: request_header(token)
  };
  let req = _.cloneDeep(param);
  delete req['ID'];
  Object.keys(req).forEach((key) => (req[key] == null) && delete req[key]);
  Object.keys(req).forEach((key) => {if(typeof(req[key]) == 'boolean'){req[key] = Number(req[key])}});
  $http.put(`${config.API}/admin/api/${endpoint}/`, req, header).then(function (res) {
    setTimeout(() => cb(res.data), 100);
  },
  function (err) {
    if(err.status == 401) {
      window.getApp.$emit("APP_AUTH_FAILED");
    }
    else if(err.status == 406) {
      sendErrorNotice(err.data.reason);
      refreshResource();
    }
  });
}

export function comment_type(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.name : '';
}

export function comment_type_color(value) {
  const cmtType = config.COMMENT_TYPE.find(obj => obj.id === value);
  return cmtType ? cmtType.color : '#e6c87f';
}

export function comment_avatar(value) {
  if (value !== null) {
    return '/android-icon-96x96.png';
  }
  return '/static/avatar/no_avatar.png';
}

export function comment_color(value) {
  if (value) {
    return '#ff0000';
  }
  return '#0000ff';
}

export function payment_type(value) {
  switch (value) {
    case 2:
    case 3:
      return "Đặt cọc";
    case 12:
      return "Hoàn tiền"
    default:
      return "Thanh toán";
  }
}

export function payment_type_color(value) {
  switch (value) {
    case 2:
      return "#e6c87f";
    case 3:
      return "#ffff00";
    case 12:
      return "#ff0000"
    default:
      return "#0000ff";
  }
}

export function complain_type(value) {
  switch (value) {
    case 1:
      return "Chờ xử lý";
    case 2:
      return "Đang xử lý";
    case 3:
      return "Đã xử lý"
    default:
      return "Đã hủy";
  }
}

export function complain_type_color(value) {
  switch (value) {
    case 1:
      return "#ff0000";
    case 2:
      return "#797960";
    case 3:
      return "#0000ff"
    default:
      return "#e6c87f";
  }
}

export function trade_type(value) {
  const cmtType = config.TRADE_TYPE.find(obj => obj.value === value);
  return cmtType ? cmtType.name : '';
}

export function print_transaction(weight, weight_v2, length, width, height, transactionCode, customerName, orderId, numberOfCode) {
  var mywindow = window.open("", "PRINT");

  mywindow.document.write("<html><head><title></title>");
  mywindow.document.write(
    "<style>.row {display: flex;}.flex {flex: 1 1 auto;}.flex.lg6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}"
  );
  mywindow.document.write(
    ".flex.lg12 {flex-basis: 100%;flex-grow: 0;max-width: 100%;}.title {font-size: 24px; font-weight: bold; text-align: center; margin: 5px 0 3px 0 !important;}"
  );
  mywindow.document.write(
    ".sub-title {font-size: 16px; font-weight: bold; margin: 0 0 8px 0 !important;}.l-text {text-align: left;}.r-text {text-align: right;}.note-text {font-size: 14px; font-weight: bold; font-style: italic; text-align: center;}"
  );
  mywindow.document.write(
    "</style></head><body style='height:8cm; width:9cm; margin-left: 5px; margin-right:5px;'>"
  );
  mywindow.document.write("<div class='layout wrap'>");
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${customerName}</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><hr class='v-divider theme--light'></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='title'>${orderId}</p></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Số kiện</p></div><div class='flex lg6'><p class='sub-title r-text'>${numberOfCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Khối lượng</p></div><div class='flex lg6'><p class='sub-title r-text'>${weight > weight_v2 ? weight : weight_v2} kg</p></div></div>`
  );
  if(weight_v2 > weight) {
    mywindow.document.write(
      `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Kích thước (cm)</p></div><div class='flex lg6'><p class='sub-title r-text'>${length} x ${width} x ${height}</p></div></div>`
    );
  }
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Mã vận đơn</p></div><div class='flex lg6'><p class='sub-title r-text'>${transactionCode}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='row'><div class='flex lg6'><p class='sub-title l-text'>Ngày tạo</p></div><div class='flex lg6'><p class='sub-title r-text'>${moment(
      new Date()
    ).format("DD-MM-YYYY")}</p></div></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Lưu ý</p></div>`
  );
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>Qúy khách vui lòng giữ lại mã vận đơn Trung Quốc để sử dụng trong trường hợp khiếu nại với shop.</p></div>`
  );
  mywindow.document.write(`<hr class='v-divider theme--light'>`);
  mywindow.document.write(
    `<div class='flex lg12'><p class='note-text'>${config.SYSTEM_CONFIG.domain}</p></div>`
  );
  mywindow.document.write("</div>");
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  mywindow.print();
  // mywindow.close();
  return true;
}

export function print_transaction_v2(item) {
  var mywindow = window.open("", "PRINT");
  let barcode_width = item.TransactionCode && item.TransactionCode.length <= 17 ? 1.86 : 1.48
  mywindow.document.write(`<html>
  <head>
      <title></title>
      <script src="https://cdn.jsdelivr.net/jsbarcode/3.5.1/JsBarcode.all.min.js"></script>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 9px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 9px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 9px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #dddddd; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; } @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } }
      </style>
  </head>
  
  <body style='width:100mm'>
      <div class='layout wrap'>
          <table>
              <tr>
                  <td class='m-text' colspan='4'><svg id="code128"></svg></td>
                  <td class='sub-title m-text'>Id Custom: ${item.UID}<br/>Order Id: ${(item.PackageType == 1 ? 'KG' : 'MD') + item.OrderID}</td>
              </tr>
              <tr>
                  <td class='body-text m-text'>FROM</td>
                  <td class='body-text' colspan='4'>Name : Guangzhou Ronghe Purchasing Agent Co. LTD
                      <br/>Mobile: +8615677000469
                      <br/>Add: Building 2, No. 181, Wanggang Xiling Road, Jiahe Street, Baiyun District, Guangzhou City, Guangdong Province, China</td>
              </tr>
              <tr>
                  <td class='body-text m-text' rowspan='3'>TO</td>
                  <td class='body-text'>Name</td>
                  <td class='body-text' colspan='3'>${item.FullName}</td>
              </tr>
              <tr>
                  <td class='body-text'>Mobile</td>
                  <td class='body-text' colspan='3'>${item.FakePhone}</td>
              </tr>
              <tr>
                  <td class='body-text'>Add</td>
                  <td class='body-text' colspan='3'>${item.Address}</td>
              </tr>
              <tr>
                  <td class='sub-title' colspan='5'>Shipment Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='2'>Service</td>
                  <td class='body-text' colspan='3'>E</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='2'>Product Quantity<br/>(Số lượng SP)</td>
                  <td class='body-text m-text'>Actual weight<br/>(Trọng lượng thực tế kg)</td>
                  <td class='body-text m-text'>Volume<br/>(Thể tich m3)</td>
                  <td class='body-text m-text'>Chargeable weight<br/>(Khối lượng tính phí)</td>
              </tr>
              <tr>
                  <td class='sub-title m-text' colspan='2'>${ currency(item.ProductNumber)}</td>
                  <td class='sub-title m-text'>${ currency(item.Weight, '', 1)}</td>
                  <td class='sub-title m-text'>${ currency(item.Volume, '', 1)}</td>
                  <td class='sub-title m-text'>${ currency(item.ChargeableWeight, '', 1)}</td>
              </tr>
              <tr>
                  <td class='sub-title' colspan='5'>Product Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='4'>Name</td>
                  <td class='body-text m-text'>Product Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='4'>${item.ProductName ? item.ProductName : ''}</td>
                  <td class='body-text m-text'></td>
              </tr>
              <tr>
                  <td class='body-text m-text' colspan='2'>Payment COD: <b>${ currency(item.ProductAmountVND)}VNĐ</b></td>
                  <td class='body-text m-text' colspan='3'>Receiver's signature<br/>(Confirm intact goods)</td>
              </tr>
          </table>
      </div>
      <script>
        JsBarcode("#code128", "${item.TransactionCode}", {format: "code128", fontSize: 16, height: 66, width: ${barcode_width}, textMargin: 2});
      </script>
  </body>
  </html>`);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  // mywindow.print();
  // mywindow.close();
  return true;
}

export function print_bigpackage(bigpackage_code, created_date, export_date, numberOfPackage, weight, volume, quantity) {
  var mywindow = window.open("", "PRINT");

  mywindow.document.write(`<html>
  <head>
      <title></title>
      <script src="https://cdn.jsdelivr.net/jsbarcode/3.5.1/JsBarcode.all.min.js"></script>
      <style>
          .row { display: flex; } .flex { flex: 1 1 auto; } .flex.lg6 { flex-basis: 50%; flex-grow: 0; max-width: 50%; } .flex.lg8 { flex-basis: 66%; flex-grow: 0; max-width: 66%; } .flex.lg4 { flex-basis: 34%; flex-grow: 0; max-width: 34%; } .flex.lg3 { flex-basis: 25%; flex-grow: 0; max-width: 25%; } .flex.lg12 { flex-basis: 100%; flex-grow: 0; max-width: 100%; } .title { font-size: 16px; font-weight: bold; text-align: center; } .sub-title { font-size: 10px; font-weight: bold; } .l-text { text-align: left; } .r-text { text-align: right; } .m-text { text-align: center; } .note-text { font-size: 10px; font-weight: bold; font-style: italic; text-align: center; } .body-text { font-size: 10px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #dddddd; text-align: left; padding: 1px; } hr { border: 0.5px solid #dddddd; } tr, td, th { page-break-inside: avoid !important; } @media print { @page { size: auto; margin: 2mm 2mm 2mm 2mm; } html { background-color: #FFFFFF; margin: 0px; } body { margin: 0mm 0mm 0mm 0mm; } }
      </style>
  </head>
  
  <body style='width:100mm'>
      <div class='layout wrap'>
          <table>
              <tr>
          <td class='body-text m-text'>Created date:</td>
          <td class='body-text m-text'>${display_date(created_date, 'DD-MM-YYYY')}</td>
                  <td class='m-text' colspan='2'><svg id="code128"></svg></td>                
              </tr>
              <tr>
                  <td class='body-text m-text'>Export date:</td>
          <td class='body-text m-text'>${display_date(export_date, 'DD-MM-YYYY')}</td>
                  <td class='body-text m-text' colspan='2'>${bigpackage_code}</td>     
              </tr>
              <tr>
                  <td class='body-text m-text' rowspan='3'>FROM</td>
                  <td class='body-text' colspan='3'>Name: VBI</td>
              </tr>
              <tr>
                  <td class='body-text' colspan='3'>Mobile:</td>
              </tr>
              <tr>
                  <td class='body-text' colspan='3'>Add: </td>
              </tr>
              <tr>
                  <td class='body-text m-text' rowspan='3'>TO</td>
                  <td class='body-text' colspan='3'>Name: LUAN-HN</td>
              </tr>
              <tr>
                  <td class='body-text' colspan='3'>Mobile:</td>
              </tr>
              <tr>
                  <td class='body-text' colspan='3'>Add: </td>
              </tr>
              <tr>
                  <td class='sub-title' colspan='4'>Shipment Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text'>Total number of packages</td>
                  <td class='body-text m-text'>Actual weight</td>
                  <td class='body-text m-text'>Volume</td>
                  <td class='body-text m-text'>Chargeable weight</td>
              </tr>
              <tr>
                  <td class='sub-title m-text'>${ currency(numberOfPackage)}</td>
                  <td class='sub-title m-text'>${ currency(weight,'',1)}</td>
                  <td class='body-text m-text'>${ currency(volume,'',1)}</td>
                  <td class='body-text m-text'></td>
              </tr>
              <tr>
                  <td class='sub-title' colspan='4'>Product Detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text'>Name:</td>
                  <td class='body-text m-text'></td>
                  <td class='body-text m-text'></td>
                  <td class='body-text m-text'>Product detail</td>
              </tr>
              <tr>
                  <td class='body-text m-text'>Payment COD:</td>
                  <td class='body-text m-text' colspan='3'>Receiver's signature<br/>(Confirm intact goods)</td>
              </tr>
          </table>
      </div>
      <script>
          JsBarcode("#code128", "${bigpackage_code}", {format: "code128", fontSize: 18, height: 68, width: 1.86, textMargin: 2, displayValue: false});
      </script>
  </body>
  </html>`);
  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/
  // mywindow.print();
  // mywindow.close();
  return true;
}